$ = require 'jquery'
Auth = require 'app/scripts/db/auth'
BoardMemberMenuView = require 'app/scripts/views/member-menu-profile/board-member-menu-view'
DragSort = require 'app/scripts/views/lib/drag-sort'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
assert = require 'app/scripts/lib/assert'
log = require 'app/scripts/debug/log'
template = require 'app/scripts/views/templates/member'

module.exports = class MemberOnBoardView extends View
  tagName: 'a'
  className: 'member js-member'
  viewTitleKey: 'change permissions'

  attributes:
    tabindex: 0

  zIndex: 0

  events:
    'click': 'showMenu'
    'keydown': 'showMenu'

  initialize: ({ @board, @notClickable, @small, @hideBadges, @zIndex }) ->
    assert @model?, "You cannot have a deleted member as a board member!"
    @listenTo @model, 'change', @render
    @listenTo @board, 'change:memberships', @render
    return

  render: ->
    log('render', "rendering #{ @constructor.name } #{ @model.get('fullName') }")
    data = @model.toJSON()

    isAdmin = (parent) =>
      membership = parent.getMembershipFor(@model)
      membership?.memberType == 'admin'

    # if the person is a BC org admin, then they are board admin, too, dang it
    data.isBoardAdmin = isAdmin(@board) ||
      @board.getOrganization()?.isPremOrgAdmin(@model)

    data.isGhost = @model.get('memberType') == 'ghost'
    data.isDeactivated = @board.isDeactivated(@model)
    data.hideBadges = @hideBadges

    @$el.html(template(data)).css('z-index', @zIndex)

    if @model.isFeatureEnabled('crown')
      @$el.addClass('has-crown')

    if @small
      @$el.addClass('m-member-mod-24')
    if @notClickable
      @$el.addClass('m-member-mod-no-click')

    @$el.toggleClass('member-deactivated js-member-deactivated', data.isDeactivated)
    @$el.toggleClass('member-virtual-invitee', data.memberType == "ghost" and (not data.idMemberReferrer? or data.idMemberReferrer == Auth.me().id))

    @$el.toggleClass('long-initials', data.initials?.length > 2)

    if data.isGhost
      @$el.addClass('member-virtual')

    @$el.data('id', @model.id)
    @

  showMenu: (e) ->
    if DragSort.sorting || @notClickable
      return

    if e.type == 'keydown'
      Util.stopPropagation(e)
      if e.key != " " && e.key != 'Enter'
        return
    else
      Util.stop(e)

    popoverMethod = if @options.pushView then 'pushView' else 'toggle'
    PopOver[popoverMethod]
      elem: e.currentTarget
      view: new BoardMemberMenuView({ @board, @model, @modelCache })

    return
